export class ActivityTime {
  constructor(
    public hash: string,
    public name: string,
    public isRunning: boolean,
    public isWarning: boolean,
    public isAlarm: boolean,
    public isOther: boolean,
    public totalTime: number
  ) { }
}



// WEBPACK FOOTER //
// /var/www/borneo/prod/borneo_app/src/app/core/models/activity-time.ts